import { Button } from '@/components';
import { RadixDialog } from '@/components/RadixDialog';
import { MasterTranslation } from '@/constants';
import { useFocusRestoration, useGlobalState } from '@/hooks';
import { ButtonColorKey, ButtonSize, IconAlignment } from '@/interfaces';
import { usePopUpsContext } from '@/modules/pmt/context';
import { PmtSignUpStep } from '@/modules/pmt/interfaces';
import Image from 'next/image';
import NotificationsIcon from '../../../../public/images/icons/notifications.svg';
import { PopupContentWrapper, PopupHeader, PopupWrapper, Subcopy, Title } from './DelayedShipmentPopup.styles';

export const DelayedShipmentPopup = () => {
  const { t, setShowPMTPopUp, setCurrentPMTSignUpStep, setIsFromDelayedShipmentBtn } = useGlobalState();

  const { showDelayedShipmentPopUp, onCloseDelayedShipmentPopUp } = usePopUpsContext();

  useFocusRestoration(showDelayedShipmentPopUp);

  const handleButtonClick = () => {
    setShowPMTPopUp(true);
    setIsFromDelayedShipmentBtn(true);
    setCurrentPMTSignUpStep(PmtSignUpStep.SignUp);
    onCloseDelayedShipmentPopUp();
  };

  return (
    <RadixDialog open={showDelayedShipmentPopUp} onOpenChange={onCloseDelayedShipmentPopUp}>
      <PopupWrapper>
        <PopupHeader>
          <Image src='/images/verify-graphic.svg' alt='Verify Graphic' fill sizes='100vw' />
        </PopupHeader>
        <PopupContentWrapper>
          <Title>{t(MasterTranslation.DelayedShipmentPopupMainText)}</Title>
          <Subcopy>{t(MasterTranslation.DelayedShipmentPopupSubText)}</Subcopy>
          <Button
            truncate={2}
            isPMTButton
            icon={NotificationsIcon}
            size={ButtonSize.Large}
            color={ButtonColorKey.Yellow}
            alignment={IconAlignment.Left}
            onClick={handleButtonClick}
            onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleButtonClick();
              }
            }}
          >
            {t(MasterTranslation.DelayedShipmentPopupButton)}
          </Button>
        </PopupContentWrapper>
      </PopupWrapper>
    </RadixDialog>
  );
};
